/**
 * Tiny localStorage-backed draft store. Used by course-creation form
 * and similar wizards so refresh/navigate doesn't lose user input.
 */
const PREFIX = 'uaqyt:draft:';
const TTL_MS = 24 * 60 * 60 * 1000; // 24h

export function readDraft(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.expiresAt && parsed.expiresAt < Date.now()) {
      localStorage.removeItem(PREFIX + key);
      return null;
    }
    return parsed.value ?? null;
  } catch {
    return null;
  }
}

export function writeDraft(key, value) {
  try {
    localStorage.setItem(
      PREFIX + key,
      JSON.stringify({ value, expiresAt: Date.now() + TTL_MS })
    );
  } catch {
    // quota exceeded — silently ignore
  }
}

export function clearDraft(key) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* noop */
  }
}
